import template from './route_control.html';
import controller from './route_control.controller';
import './route_control.scss';

let routeControlComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default routeControlComponent;

     


// WEBPACK FOOTER //
// ./client/app/components/route_control/route_control.component.js